import { Templates } from './templates';
import { IRenderer } from '../renderer';
import { FormManifestCheckDescriptor } from '../../../modules/form.manifest/model/form.manifest.check';

export class FormCheckRenderer implements IRenderer {
  RenderHeader(preview: any) {
    if (preview as FormManifestCheckDescriptor) {
      const formCheck = preview as FormManifestCheckDescriptor;
      return '<a>' + 'Űrlap manifest ellenőrzés részletei.' + '</a>';
    }
    return '<b>invalid databinding</b>';
  }
  RenderBody(preview: any) {
    let html = '<ul class="bulletless">';
    if (preview as FormManifestCheckDescriptor) {
      const formCheck = preview as FormManifestCheckDescriptor;
      if (formCheck.errorMessage) {
        html += Templates.listItem('Hiba üzenet:', formCheck.errorMessage);
      }
      if (formCheck.htmlLine) {
        html += Templates.listItem('Sor:', formCheck.htmlLine);
      }
    }
    html += '</ul>';
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/form.check.renderer.ts